<template>
  <create-main @back="goBack"
               :width="'1000px'">
    <template slot="nav">
      <div class="editNav">
        <p class="title">创建<template v-if="this.session_type==='practice'">实践</template><template v-else>考试</template>教案</p>
      </div>
    </template>
    <template slot="main">
      <div class="editMain">
        <div class="session_tool">
          <template v-if="flashFlag">
            <object type="application/x-shockwave-flash" id="session_tool" name="session_tool" align="middle" :data="`${hostUrl}/uploads/flash-tool/yioks-preloader.swf?revision=1463`" width="100%"
                    style="margin-top:0px !important;">
              <param name="quality" value="high">
              <param name="bgcolor" value="#ffffff">
              <param name="play" value="false">
              <param name="loop" value="false">
              <param name="wmode" value="opaque">
              <param name="scale" value="showall">
              <embed wmode="opaque"/>
              <param name="menu" value="true">
              <param name="devicefont" value="false">
              <param name="salign" value="">
              <param name="allowscriptaccess" value="sameDomain">
              <param name="allowfullscreen" value="true">
              <param name="allowFullScreenInteractive" value="true">
              <param name="base" value="images/flash">
              <param name="flashvars"
                     :value="`selectedMovie=${hostUrl}/uploads/flash-tool/yioks-football-editor.swf&amp;xmlRequestFile=${defaultUrl}%26gotourl=${gotoUrl}&amp;globalRequestFile=/api/xml/global_data&amp;revision=1464`">
            </object>
          </template>
          <template v-if="flashTipsFlag">
            <flash-tips></flash-tips>
          </template>
        </div>
      </div>
      <yioks-tips :showTips="tipsFlag"
                  :tips="'确定放弃修改并返回吗？'"
                  @hideTips="hideTipsDialog"></yioks-tips>
    </template>
  </create-main>
</template>

<script>
  export default {
    name: "create-tutorial",
    beforeRouteEnter (to, from, next) {
      next((vm)=>{
        vm.$set(vm.backRoute, "path", from.path);
        vm.$set(vm.backRoute, "query", from.query);
      });
    },
    data() {
      const userInfo = this.$store.state.userInfo;
      const member_type = userInfo.member_type;
      const hostUrl = process.env.VUE_APP_URL;
      const session_type = this.$route.query.session_type;
      const class_level = userInfo.class_level;
      let defaultUrl;
      let sessionSkillLevelId = this.getsessionSkillLevelId(class_level);
      const sessionCategoryId =this.$route.query.sessionCategoryId
      if(session_type ==='practice') {
        if (sessionCategoryId){
          defaultUrl = `/api/xml/tactical_data%3fplan_id%3d1%26uid%3d${userInfo.uid}%26session_type%3d${session_type}%26sessionSkillLevelId%3d${sessionSkillLevelId}%26member_type%3d${member_type}%26sessionCategoryId%3d${sessionCategoryId}`;
        }else{
          defaultUrl = `/api/xml/tactical_data%3fplan_id%3d1%26uid%3d${userInfo.uid}%26session_type%3d${session_type}%26sessionSkillLevelId%3d${sessionSkillLevelId}%26member_type%3d${member_type}`;
        }
      } else if (session_type ==='exam' && (class_level==='C' || class_level==='B')) {
        defaultUrl = `/api/xml/tactical_data%3fplan_id%3d101%26uid%3d${userInfo.uid}%26session_type%3d${session_type}%26sessionSkillLevelId%3d${sessionSkillLevelId}%26member_type%3d${member_type}`;
      }else if (session_type ==='exam') {
        defaultUrl = `/api/xml/tactical_data%3fplan_id%3d100%26uid%3d${userInfo.uid}%26session_type%3d${session_type}%26sessionSkillLevelId%3d${sessionSkillLevelId}%26member_type%3d${member_type}`;
      }
      let gotoUrl = `student%2Ftutorial_other`;
      if(sessionCategoryId){
        gotoUrl = `teacher%2Ftutorial_list`;
      }
      return {
        backRoute: {
          path: "",
          query: {}
        },
        tipsFlag: false,
        hostUrl,
        session_type,
        defaultUrl,
        gotoUrl,
        flashFlag: false,
        flashTipsFlag: false,
      };
    },
    components: {
      "create-main": () => import("@/components/LayOut/Common/up-down"),
      "flash-tips": () => import("@/components/Tutorial/flash-tips"),
      "yioks-tips": () => import("@/components/Tips/Dialog")
    },
    created() {
      this.flashFlag = this.$yioks.flashChecker();
      this.flashTipsFlag = !this.flashFlag;
    },
    methods: {
      getsessionSkillLevelId(val){
        switch (val) {
          case 'D' :
            return '8';
            break;
          case 'early' :
            return '8';
            break;
          case 'C' :
            return '12';
            break;
          case 'B' :
            return '16';
            break;
          case 'A' :
            return '19';
            break;
          case 'PRO' :
            return '19';
            break;
          default :
            return  '0';
            break
        }
      },
      goBack() {
        // this.$router.go(-1);
        //this.$router.push(this.backRoute);
        this.tipsFlag = true;
      },
      hideTipsDialog(bool, sure) {
        this.tipsFlag = bool;
        if (sure) {
          this.$router.push(this.backRoute);
        } else {

        }
      }
    }
  };
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  .editNav, .editMain {
    flex: 1 1 auto;
    height: 100%;
  }

  .editNav {
    display: flex;
    align-items: center;
    font-size: $font_size_big;
  }

  .editMain {
    width: 100%;
    .session_tool {
      width: 100%;
      height: 600px;
      background-color: $block_bg_color_base;
      #session_tool {
        height: 600px;
      }
    }
  }
</style>
